<mat-card>
    <mat-card-content class="p-16">
        <div class="stepper-container">
            <div *ngFor="let item of items; let i = index; let last = last" class="step-wrapper" [class.has-line]="!last">
                
                <div class="step-content">
                    <div class="step-indicator" 
                        [class.completed]="isCompleted(i)"
                        [class.active]="isActive(i)">
                        <mat-icon *ngIf="isCompleted(i)">check</mat-icon>
                        <span *ngIf="!isCompleted(i)">{{ i + 1 }}</span>
                    </div>

                    <span class="step-label" [class.active]="isActive(i)">
                        {{ item.text }}
                    </span>
                </div>

                <div class="step-line" *ngIf="!last"></div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
